<template>
    <div class="xxx-modal flex flex-col items-center justify-center h-full">
        <div class="box-container bg-white py-6 px-12 shadow-lg text-center shadow-text-none rounded">
            <i class="fas fa-volume-up font-size-50 mb-5 main-color"></i>
            <h1 class="mt-0 md:font-size-22 font-size-18 mb-4">{{ $t('playalone_has_sound') }}<br> {{ $t('playalone_pump_volume') }}</h1>
            <div @click="onClick" id="playWithSound" class="btn text-xl font-size-22 font-opensans">{{ $t('playalone_button_play') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'before-quiz-modal',

    methods: {
        onClick () {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.xxx-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.box-container {
    min-width: 280px;
}
.main-color {
    color: var(--nav-color);
}
.h-full {
    @media (max-width: 767px) {
        height: calc((var(--vh, 1vh) * 100) - 1rem);
    }
}
</style>